import { render, staticRenderFns } from "./moduleName.vue?vue&type=template&id=22960aaf&scoped=true"
import script from "./moduleName.vue?vue&type=script&lang=js"
export * from "./moduleName.vue?vue&type=script&lang=js"
import style0 from "./moduleName.vue?vue&type=style&index=0&id=22960aaf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22960aaf",
  null
  
)

export default component.exports